import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '../../../../components/layout/PageHeader';
import { OpenAIAdminKeyCard } from '../../../../components/settings/OpenAIAdminKeyCard';

function SettingsPage() {
  return (
    <>
      <PageHeader
        title="Platform Ayarları"
        description="Sistem-geneli credential ve entegrasyon ayarları"
      />
      <div className="p-6 max-w-3xl space-y-6">
        <OpenAIAdminKeyCard />
      </div>
    </>
  );
}

export const Route = createFileRoute('/_app/admin/settings/')({ component: SettingsPage });
